import { Button } from "@/components/core/buttons/button";
import Combobox from "@/components/core/forms/combobox";
import { Form } from "@/components/core/forms/form.tsx";
import { FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLookUpItemCreateMutation } from "../api/queries/look-up-item-queries";
import branchCaseType from "../api/services/branch-case-type-service";
import caseCategoryService from "../api/services/case-category-service";
import { type Category, categorySchema } from "../types/categories";

export default function CategoryModal({ data, branchId }: { data?: Category; branchId: string }) {
	const { closeModal } = useModalControl();
	const lookUpItemMutation = useLookUpItemCreateMutation();

	const form = useForm<Category>({
		resolver: zodResolver(categorySchema),
		defaultValues: {
			case_type_id: data?.case_type_id || "",
			case_category_id: data?.case_category_id || "",
		},
	});

	const selectedCategoryId = form.watch("case_category_id");
	console.log(selectedCategoryId, "tst");

	const handleSubmit = async (values: Category) => {
		await lookUpItemMutation.mutateAsync({
			...values,
			branchId,
		});
		closeModal();
	};

	useEffect(() => {
		if (selectedCategoryId) {
			form.setValue("case_type_id", "");
		}
	}, [selectedCategoryId]);

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						<div className="col-span-12 w-full">
							<FormField
								control={form.control}
								name="case_category_id"
								render={({ field }) => (
									<FormItem>
										<div className="flex flex-col w-full">
											<FormLabel required>Case Category</FormLabel>
										</div>
										<FormGroup iconPosition="left">
											<Combobox
												onValueChange={field.onChange}
												// placeholder={data?.case_category?.name}
												loadOptions={async (value: string) => {
													const items = await caseCategoryService.list({
														"filter[search]": value,
													});

													return items.data.map((item) => ({
														label: item.name,
														value: item.id,
													}));
												}}
											/>
										</FormGroup>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>

						<div className="col-span-12 w-full">
							<FormField
								control={form.control}
								name="case_type_id"
								render={({ field }) => (
									<FormItem>
										<div className="flex flex-col w-full">
											<FormLabel required>Category Type</FormLabel>
										</div>
										<FormGroup iconPosition="left">
											{/* <Combobox
												onValueChange={field.onChange}
												// placeholder={data?.case_category?.name}
												loadOptions={async (value: string) => {
													const items = await typeCategoryService.list({
														"filter[search]": value,
													});

													return items.data.map((item) => ({
														label: item.name,
														value: item.id,
													}));
												}}
											/> */}
											<Combobox
												key={selectedCategoryId}
												disabled={!selectedCategoryId}
												onValueChange={field.onChange}
												loadOptions={async (value: string) => {
													const items = await branchCaseType.list({
														"filter[search]": value,
														"filter[case_category_id]": selectedCategoryId,
													});

													return items.data.map((item) => ({
														label: item.name,
														value: item.id,
													}));
												}}
											/>
										</FormGroup>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-2">
					<Button className="" variant="ghost">
						Cancel
					</Button>
					<Button className="" variant="default">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
